<template>
    <v-card>
        <v-card-title>
            <span class="display-1">Histórico modificaciones en HMI reguladores</span>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-data-table :items="datos" :headers="headers" :loading="loading">

            <template v-slot:[`item.created_at`]="{ item }">
                {{fechaFormateada(item.created_at)}}
            </template>

        </v-data-table>
    </v-card>
</template>

<script>
import moment from 'moment-timezone';
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            datos: [],
            items: [],
            headers: [
                // {text: "ID", align: 'center', value: 'id'},
                // {text: "Nombre Ciclo", align: 'center', value: 'nombre_columna'},
                {text: "Valor Cambiado", align: 'center', value: 'nombre_tratado'},
                {text: "Valor asignado", align: 'center', value: 'valor'},
                {text: "Realizado por", align: 'center', value: 'name'},
                {text: "Fecha Realizacion", align: 'center', value: 'created_at'},
                // {text: "ID usuario", align: 'center', value: 'id_usuario'},
            ],
            loading: true,
            ids: [],
        }
    },
    methods: {
        ...mapActions(['getData']),
        fechaFormateada(fecha){
            return moment(fecha).format('YYYY-MM-DD HH:mm:ss')
        },
        async getHMIModificaciones(){
            // const res = await this.axios.get('/get-hmi-modificaciones')
            const payload = {
                path : 'hmi/get-hmi-modificaciones',
                params : {}
            }
            const res = await this.getData(payload);
            this.items = res.results;
            this.items.forEach(element => {
                element['nombre_tratado'] = this.cambiarNombre(element.nombre_columna)
                this.datos.push(element)
            });
            this.loading = false
        },
        cambiarNombre(topic){
            switch (topic) {
                case 'SP_Max_Auto_Colector':
                    return 'SP Temperatura Max. Colector Ciclo Secado'
                    break;
                case 'SpSecadoAutoTromel':
                    return 'SP Temperatura Tromel Ciclo Secado'
                    break;
                case 'SpEsterilizadoAutoTromel':
                    return 'SP Temperatura Tromel Ciclo 1 Higienización'
                    break;
                case 'SpEsterilizadoAutoTromel2':
                    return 'SP Temperatura Tromel Ciclo 2 Higienización'
                    break;
                case 'Time_horas_E4_ciclo_secado':
                    return 'Tiempo Máximo Ciclo Secado -> HORAS'
                    break;
                case 'Time_min_E4_ciclo_secado':
                    return 'Tiempo Máximo Ciclo Secado -> MINUTOS'
                    break;
                case 'Time_seg_E4_ciclo_secado':
                    return 'Tiempo Máximo Ciclo Secado -> SEGUNDOS'
                    break;
                case 'Time_horas_E5_ciclo_esterilizado':
                    return 'Tiempo Máximo Ciclo 1 Higienización -> HORAS'
                    break;
                case 'Time_min_E5_ciclo_esterilizado':
                    return 'Tiempo Máximo Ciclo 1 Higienización -> MINUTOS'
                    break;
                case 'Time_seg_E5_ciclo_esterilizado':
                    return 'Tiempo Máximo Ciclo 1 Higienización -> SEGUNDOS'
                    break;
                case 'Time_horas_E5_Ciclo_Esterilizado2':
                    return 'Tiempo Máximo Ciclo 2 Higienización -> HORAS'
                    break;
                case 'Time_min_E5_ciclo_esterilizado2':
                    return 'Tiempo Máximo Ciclo 2 Higienización -> MINUTOS'
                    break;
                case 'Time_seg_E5_ciclo_esterilizado2':
                    return 'Tiempo Máximo Ciclo 2 Higienización -> SEGUNDOS'
                    break;
                case 'Time_horas_E9_Espera_Descarga':
                    return 'Tiempo Máximo Descargar -> HORAS'
                    break;
                case 'Time_min_E9_Espera_Descarga':
                    return 'Tiempo Máximo Descargar -> MINUTOS'
                    break;
                case 'Time_seg_E9_Espera_Descarga':
                    return 'Tiempo Máximo Descargar -> SEGUNDOS'
                    break;
                case 'Time_horas_EParo_Sec_con_Soplante':
                    return 'Tiempo Máximo Soplante ciclo Enfriado o Interrumpido -> HORAS'
                    break;
                case 'Time_min_EParo_Sec_con_Soplante':
                    return 'Tiempo Máximo Soplante ciclo Enfriado o Interrumpido -> MINUTOS'
                    break;
                case 'Time_seg_EParo_Sec_con_Soplante':
                    return 'Tiempo Máximo Soplante ciclo Enfriado o Interrumpido -> SEGUNDOS'
                    break;
                case 'Referencia_Auto_Variador_Ventilador':
                    return 'Referencia Velocidad Soplante'
                    break;
                case 'Referencia_Descarga_Variador_Ventilador':
                    return 'Referencia Velocidad Soplante Descarga'
                    break;
                case 'Referencia_Auto_Variador_Tromel':
                    return 'Referencia Velocidad Tromel'
                    break;
                case 'Referencia_Pos_Lenta_Variador_Tromel':
                    return 'Referencia Velocidad Tromel Posicionador'
                    break;
                default:
                    return topic
                    break;
            }
        }
    },
    async created() {
        await this.getHMIModificaciones()
    },
}
</script>

<style>
    
</style>